<template>
  <div class="real-time-task" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>添加</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="name" label="任务名"> </el-table-column>
        <el-table-column prop="number" label="设备id"> </el-table-column>
        <el-table-column prop="file" label="媒体"> </el-table-column>
        <el-table-column prop="volume" label="音量"> </el-table-column>
        <el-table-column prop="edit" label="设置音量" width="250" align="center">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="(dialogVolume = true), openVolumeWin(scope.row)"
              round
              >设置</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="是否启用计划">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.ste"
              :active-value="1"
              :inactive-value="0"
              @change="changeSwitch(scope.row.id, scope.row.ste)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="edit" label="编辑" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      custom-class="mw-edit-dialog"
      class="dialog600"
      :title="editType === 'create' ? '添加即时任务' : '修改即时任务'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item label="任务名" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>

          <el-form-item label="设备编号" prop="number_arr">
            <el-select
              placeholder="请选择设备编号"
              multiple
              v-model="editOne.number_arr"
              style="width: 100%"
            >
              <el-option
                v-for="t in devSelect"
                :key="t.value"
                :label="t.label"
                :value="t.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="配置音频" prop="file_arr">
            <el-select
              placeholder="请选择音频文件"
              multiple
              v-model="editOne.file_arr"
              style="width: 100%"
            >
              <el-option
                v-for="t in mediaSelect"
                :key="t.value"
                :label="t.label"
                :value="t.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="音量" prop="volume">
            <el-input-number
              v-model="editOne.volume"
              size="small"
              :min="0"
              :max="100"
              :step="5"
            ></el-input-number>
          </el-form-item>


          
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--设置音量-->
    <el-dialog
      class="dialog400"
      v-if="dialogVolume"
      title="设置音量"
      :visible.sync="dialogVolume"
    >
      <el-form
        :model="editVolume"
        label-position="left"
        label-width="80px"
        :rules="editVolumeRule"
        ref="setVolume"
      >
        <el-form-item label="音量" prop="volume">
          <el-input v-model="editVolume.volume"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVolume = false"
          >取消</el-button
        >
        <el-button type="primary" @click="setVolume"
          >确 定</el-button
        >
      </div>
    </el-dialog>

  </div>
</template>

<script>
import smileApi from "@/api/smile/index";
import realtimeApi from "@/api/smile/realtime";
import mediaApi from "@/api/smile/media";
import dalogMediaList from '@/components/audio/realtime/dalogMediaList.vue'
export default {
  components:{ 
    dalogMediaList
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogVolume: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: "请输入任务名", trigger: "blur" }],
      },
      editVolumeRule: {
        volume: [{ required: true, message: "请输入声音", trigger: "blur" }],
      },
      editType: -1,
      cnt_all: 0,
      pages: {
        page: 1,
        pageSize: 10,
      },
      devSelect: [],
      mediaSelect: [],
      editOne: {
        name: "",
        volume: 0,
        number: "",
        number_arr: [],
        file: "",
        file_arr: [],
      },
      editVolume: {
        task_id: null,
        volume: 0,
      },
      token: ''
    };
  },
  methods: {
    getToken() {
      smileApi.smileToken().then((res) => {
        if (res.data.code === 1000) {
          this.token = res.data.accessToken
        }
      });
    },
    getTableData(pageIndex) {
      // 获取任务列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      realtimeApi.realtimeList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.audioDeviceList();
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val
      this.getTableData(this.pageInfo.page)
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val
      this.getTableData(this.pageInfo.page)
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: "",
          volume: 0,
          number: "",
          number_arr: [],
          file: "",
          file_arr: [],
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          volume: index.volume,
          number: index.number,
          number_arr: index.number.split(','),
          file: index.file,
          file_arr: index.file.split(','),
        };
        this.editType = "update"
      }
      this.dialogVisible = true;
    },
    openVolumeWin(index) {
      //设置音量
      this.editVolume.task_id = index.id;
      this.editVolume.volume = index.volume;
      this.dialogVolume = true;
      this.editOne = {
        id: index.id,
        name: index.name,
        volume: index.volume,
        number: index.number,
        file: index.file
      };
    },

    updateItem() {
      this.editOne.number = this.editOne.number_arr.toString();
      this.editOne.file = this.editOne.file_arr.toString();
      this.editOne.token = this.token;
      realtimeApi.realtimeEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.dialogVisible = false;
          this.$message.success("操作成功！");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      this.editOne.number = this.editOne.number_arr.toString();
      this.editOne.file = this.editOne.file_arr.toString();
      this.editOne.token = this.token;
      realtimeApi.realtimeAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.afterTask();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    afterTask() {
      realtimeApi.afterRealTimeTask({
        token: this.token
      }).then((res) => {
        this.dialogVisible = false;
        if (res.data.code === 1000) {
          this.$message.success("操作成功！");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        realtimeApi.realtimeDel(id,{
          token: this.token
        }).then((res) => {
          this.dialogVisible = false;
          if (res.data.code === 1000) {
            this.$message.success("删除成功");
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },

    setVolume() {
      this.$refs["setVolume"].validate((valid) => {
        if (valid) {
          this.editOne.volume = this.editVolume.volume;
          this.editOne.token = this.token;
          realtimeApi.realtimeEdit(this.editOne.id, this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.dialogVolume = false;
              this.$message.success("操作成功！");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },

    audioDeviceList() {
      // 获取所有的IP广播
      smileApi.smileList({
          page: 1,
          pageSize: 200,
        })
        .then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data.list;
            let devData = [];
            for (let i = 0; i < resData.length; i++) {
              let devobj = {
                value: resData[i].number,
                label:resData[i].name
              };
              devData[i] = devobj;
            }
            this.devSelect = devData;
            this.mediaList()
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    mediaList() {
      // 获取所有的音频文件
      mediaApi.mediaList({
          page: 1,
          pageSize: 200,
        })
        .then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data.list;
            let mediaData = [];
            for (let i = 0; i < resData.length; i++) {
              let mediaobj = {
                value: resData[i].file_id,
                label:resData[i].name
              };
              mediaData[i] = mediaobj;
            }
            this.mediaSelect = mediaData;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    changeSwitch(id, ste) {
      realtimeApi.taskSet(id, { 
        token: this.token,
        ste: ste
      }).then((res) => {
        this.getTableData(this.pageInfo.page);
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  },
  async mounted() {
    await this.getToken();
    await this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.real-time-task {
  width: 100%;
  .form-info{
    padding-left: 5px;
    .el-form-item__label{
      width:80px;
    }
  }
}
</style>